export default __webpack_public_path__ + "static/media/epauleAgneau.347c3568.jpg";